import { ModalState } from './constants';
export const getSubmitButtonLabel = (modalState, isAddToCart = false, isCartPage = false, { successButton, clearButton, continueButton }) => {
    if (modalState === ModalState.SUCCESS) {
        return successButton;
    }
    return isAddToCart || isCartPage ? clearButton : continueButton;
};
export const getOnSubmitCallback = (modalState, isAddToCart = false, isCartPage = false, { handleHideModal, handleClearCart, handleProceedToCheckout }) => {
    if (modalState === ModalState.SUCCESS) {
        return handleHideModal;
    }
    return isAddToCart || isCartPage ? handleClearCart : handleProceedToCheckout;
};
